import { keepPreviousData } from "@tanstack/react-query";

import { useApiQuery } from "app/modules/api-client";

import { useAlertsParams } from "./useAlertsParams";

const activationSetQueryOptions = {
    placeholderData: keepPreviousData,
};

export const useActivationSet = () => {
    const { activationId } = useAlertsParams();
    const { data: activationSet, isLoading } = useApiQuery(
        {
            tag: "Activation",
            methodName: "userdataActivationDetail",
            options: activationSetQueryOptions,
        },
        activationId,
    );

    return {
        activationSet,
        isLoading,
    };
};
